import { Layout } from "antd";
import PropTypes from "prop-types";

const { Content } = Layout;

const DashboardLogo = ({ theme = "light" }) => (
  <Content
    style={{
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      height: "80vh",
    }}
  >
    <img width="200" src={`/logo.${theme}.svg`} />
  </Content>
);

DashboardLogo.propTypes = {
  theme: PropTypes.string,
};

export default DashboardLogo;
